import { createAction, props } from '@ngrx/store';
import { IRAOptions, IRATypes } from '@shared/models';

import {
  ISelectedAccount,
  TransactionTypesEnum,
} from '../../reducers/selected-client-accounts/selected-client-accounts.reducer';

export const UpdateSelectedAccountsFrom = createAction(
  '[Selected Client Accounts] Update Selected Account(s) From',
  props<{ payload: ISelectedAccount[] }>(),
);

export const UpdateSelectedAccountTo = createAction(
  '[Selected Client Accounts] Update Selected Account To',
  props<{ payload: ISelectedAccount }>(),
);

export const ClearSelectedAccount = createAction(
  '[Selected Client Accounts] Clear Selected Account',
);

export const UpdateTransactionType = createAction(
  '[Selected Client Accounts] Update Transaction Type',
  props<{ payload: TransactionTypesEnum }>(),
);
export const UpdateIraType = createAction(
  '[Selected Client Accounts] Update IRA Account Type',
  props<{ payload: IRATypes }>(),
);

export const UpdateIraOption = createAction(
  '[Selected Client Accounts] Update IRA Account Option',
  props<{ payload: IRAOptions }>(),
);

export const UpdateHasEligibleExistingAccount = createAction(
  '[Selected Client Accounts] Update Has Eligible Existing Account',
  props<{ payload: boolean }>(),
);
